import Badge from '@adsk/alloy-react-badge';

export const Statuses = {
  OPEN: 'open',
  ONGOING: 'ongoing',
  CLOSED: 'closed',
};

export const colorByThreadStatus = {
  [Statuses.OPEN]: Badge.COLORS.YELLOW,
  [Statuses.ONGOING]: Badge.COLORS.BLUE,
  [Statuses.CLOSED]: Badge.COLORS.GRAY_200,
};
